<template>
    <Fieldset :title="$t('labels.basic_information')">
        <div class="row">
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.name')" :required="true">
                    <Input v-model="exitDeclarationStatus.name" type="string" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.type')" :required="true">
                    <Select v-model="exitDeclarationStatus.type" :options="exitDeclarationStatusTypesOptions" :disabled="exitDeclarationStatus.uuid != null" optionKey="key" optionValue="value" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.color')" :required="true">
                    <Input v-model="exitDeclarationStatus.color" type="color" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.queue')">
                    <Input v-model="exitDeclarationStatus.order" type="string" />
                </FormGroup>
            </div>
        </div>
    </Fieldset>
</template>
<script>
import Input from '../../../../../components/new/form/Input.vue'
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue'
import Fieldset from '../../../../../components/new/AppFieldset.vue'
import Select from '../../../../../components/new/form/select/Select.vue'
import { ExitDeclarationStatusTypeEnum } from '../../../../enums/ExitDeclarationStatusTypeEnum'
export default {
    name: "ExitDeclarationStatusFieldsetGroup",
    components: {
        Input, FormGroup, Fieldset, Select
    },
    props: {
        exitDeclarationStatus: {
            type: Object,
            required: true
        }
    },
    computed: {
        exitDeclarationStatusTypesOptions() {
            return Object.values(ExitDeclarationStatusTypeEnum).map((value) => {
                return {
                    key: value,
                    value: this.$t(`enum.exit-declaration-status.type.${value}`)
                }
            })
        }
    }
}
</script>
